import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { listDisabledStaffDeviceMaps, deleteDeviceMap } from "../../api/attendanceApi";

/**
 * Direct port of digicampusbd's `staff-attendance-disabled-machine-map`
 * ("Disabled HRM ID"). Confirmed via `StaffDeviceMapService
 * .disabledStaffDeviceMapList`'s own native SQL that — despite the label —
 * this is NOT "disabled mappings", it's "device maps belonging to staff
 * whose `staff_status=0` (deactivated staff)", contrasted with the already-
 * built `staff-attendance-machine-map` (active staff only). New repository
 * method (`findByInstituteAndStaff_StaffStatus`) + service method +
 * `GET /api/attendance/device-maps/staff/disabled`; reuses the already-
 * existing `deleteDeviceMap` for removal.
 */
export default function StaffDisabledDeviceMapPage() {
  const [maps, setMaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    listDisabledStaffDeviceMaps()
      .then(setMaps)
      .catch(() => setError("Failed to load disabled staff device maps."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (map) => {
    if (!window.confirm(`Remove device mapping for "${map.personName}"?`)) {
      return;
    }
    try {
      await deleteDeviceMap("STAFF", map.id);
      setMaps((prev) => prev.filter((m) => m.id !== map.id));
    } catch (err) {
      setError("Failed to delete device map.");
    }
  };

  const columns = [
    { key: "customPersonId", label: "Staff ID" },
    { key: "personName", label: "Name" },
    { key: "userId", label: "Device User ID" },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Disabled HRM ID</h1>
      </div>
      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={maps}
          actions={(map) => (
            <button type="button" className="btn-link danger" onClick={() => handleDelete(map)}>
              Delete
            </button>
          )}
        />
      )}
    </MainLayout>
  );
}
